module.exports = __webpack_public_path__ + "static/media/wrench.44817505.png";